import { createContext } from 'react';

export const BreadCrumbContext = createContext("");
export const BreadCrumbHcrContext = createContext("");
export const AllContext = createContext("");
